module.exports = __webpack_public_path__ + "assets/images/7b29466475ead9d931bbf95772c8065b.png";